import { useCallback, useState } from 'react'
import {
  generateIcsFile,
  downloadIcsFile
} from '../../helpers/appointments/generateIcsFile'

export const useAppointmentIcs = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const [data, setData] = useState(null)
  const [result, setResult] = useState(null)

  const download = useCallback(async appointment => {
    setIsLoading(true)
    setError(null)
    setResult(null)
    try {
      const ics = generateIcsFile(appointment)
      setData(ics)
      try {
        downloadIcsFile(ics, `${appointment?.appointmentType}.ics`)
        setResult({ action: 'downloaded' })
      } catch (downloadErr) {
        throw Object.assign(
          downloadErr || new Error('Failed to download ICS file'),
          {
            code: 'DOWNLOAD_FAILED'
          }
        )
      }
    } catch (err) {
      const code =
        err?.code ||
        (typeof err?.message === 'string' &&
        err.message.startsWith('Invalid appointment data')
          ? 'INVALID_DATA'
          : 'DOWNLOAD_FAILED')
      setError({ code, message: err?.message || 'Failed to generate ICS file' })
    } finally {
      setIsLoading(false)
    }
  }, [])

  const reset = useCallback(() => {
    setIsLoading(false)
    setError(null)
    setData(null)
    setResult(null)
  }, [])

  return { download, isLoading, error, data, result, reset }
}
